import './filter-history-points.scss'

import React, { useEffect, useState } from 'react'

import useWindowDimensions from '../../../../../../hooks/useWindowDimensions'
import { AdaptiveCarousel } from '../../../../../common/AdaptiveCarousel'

interface FilterHistoryPointsProps {
  filter: number | undefined
  setFilter: React.Dispatch<React.SetStateAction<number | undefined>>
  isLoading?: boolean
}

const dataMockMonths = [
  {
    month: 0,
    labelShort: 'Jan',
    label: 'Janeiro',
  },
  {
    month: 1,
    labelShort: 'Fev',
    label: 'Fevereiro',
  },
  {
    month: 2,
    labelShort: 'Mar',
    label: 'Março',
  },
  {
    month: 3,
    labelShort: 'Abr',
    label: 'Abril',
  },
  {
    month: 4,
    labelShort: 'Mai',
    label: 'Maio',
  },
  {
    month: 5,
    labelShort: 'Jun',
    label: 'Junho',
  },
  {
    month: 6,
    labelShort: 'Jul',
    label: 'Julho',
  },
  {
    month: 7,
    labelShort: 'Ago',
    label: 'Agosto',
  },
  {
    month: 8,
    labelShort: 'Set',
    label: 'Setembro',
  },
  {
    month: 9,
    labelShort: 'Out',
    label: 'Outubro',
  },
  {
    month: 10,
    labelShort: 'Nov',
    label: 'Novembro',
  },
  {
    month: 11,
    labelShort: 'Dez',
    label: 'Dezembro',
  },
]

export const FilterHistoryPoints = ({
  filter,
  setFilter,
  isLoading,
}: FilterHistoryPointsProps) => {
  const [didMount, setDidMount] = useState(false)
  const { width } = useWindowDimensions()
  const isMobileWidth = width && width <= 768

  const setVisibleElementSelected = (item: number) => {
    const elementFilterCarousel = document.querySelector(
      '.history-points-filter .carousel-container'
    )

    const elementFilterItem =
      elementFilterCarousel?.querySelectorAll('.container-item')?.[item]

    if (elementFilterCarousel && elementFilterItem) {
      const valueAmountVisible = !isMobileWidth ? 70 : 0

      elementFilterCarousel.scrollLeft =
        elementFilterItem?.clientWidth * item - valueAmountVisible
    }
  }

  useEffect(() => {
    if (filter === undefined) {
      const currentMonth = new Date()?.getMonth()

      setFilter(currentMonth)
      setDidMount(true)
    }
  }, [])

  useEffect(() => {
    if (didMount) {
      const currentMonth = new Date()?.getMonth()

      setVisibleElementSelected(currentMonth)
    }
  }, [didMount])

  return (
    <>
      <div className="history-points-filter">
        <ul>
          <AdaptiveCarousel
            activeBlur={!isMobileWidth}
            quantity={12}
            quantityToCarousel={6}
            propsCarousel={{
              gapItems: 0,
              qtyItems: width && width >= 1024 ? 6 : 4,
              itemWidthProp: !isMobileWidth ? 156 : 144,
              bullet: { isVisible: false },
              arrow: {
                isVisible: !isMobileWidth,
                style: { height: '20px', width: '16px', cursor: 'pointer' },
              },
            }}
          >
            {dataMockMonths?.map((item) => (
              <li
                key={item?.label}
                className={`${filter === item?.month ? 'selected' : ''} ${isLoading ? 'loading' : ''}`}
                onClick={() => {
                  if (!isLoading) {
                    setFilter(item?.month)
                  }
                }}
              >
                {isMobileWidth ? item?.labelShort : item?.label}
              </li>
            ))}
          </AdaptiveCarousel>
        </ul>
      </div>
    </>
  )
}
